export const HIGH_SCORES_UPDATE = 'HIGH_SCORES::HIGH_SCORES_UPDATE';
export const HIGH_SCORES_LOADED = 'HIGH_SCORES::HIGH_SCORES_LOADED';
export const HIGH_SCORES_LOADING = 'HIGH_SCORES::HIGH_SCORES_LOADING';
export const HIGH_SCORES_FAILED = 'HIGH_SCORES::HIGH_SCORES_FAILED';
